export default __webpack_public_path__ + "static/media/docker.48b052bd.svg";